module.exports = __webpack_public_path__ + "static/media/calendar-flow.d4724beb.svg";